import { render, staticRenderFns } from "./fback-radio.vue?vue&type=template&id=64266c3f&scoped=true&"
import script from "./fback-radio.vue?vue&type=script&lang=js&"
export * from "./fback-radio.vue?vue&type=script&lang=js&"
import style0 from "./fback-radio.vue?vue&type=style&index=0&id=64266c3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64266c3f",
  null
  
)

export default component.exports